<template>
  <div>
    <page-header
      icon="mdi-truck-fast"
      :title="$t('companies_delivery')"
      :subtitle="$t('manage_delivery_companies')"
    >
      <template #actions>
        <v-row no-gutters align="center">
          <v-btn small text color="primary" class="mr-2" @click="$emit('new-view')">
            <v-icon left small>mdi-auto-fix</v-icon>
            {{ $t("report_desktop.new_view") }}
          </v-btn>
          <primary-button
            @click="editCompany({ ...deliveryCompany })"
            v-if="canManageCompanies && $store.state.restaurant != null"
          >
            <v-icon class="mr-2">mdi-plus-circle</v-icon>
            {{ $t("add") }}
          </primary-button>
          <print-button v-if="$store.state.restaurant != null" @click="print('print')" />
        </v-row>
      </template>
    </page-header>

    <page-toolbar
      v-model="search"
      :search-placeholder="$t('search_delivery_companies_placeholder')"
    />

    <div class="px-6 mt-2">
      <v-data-table
        :headers="headers"
        :items="deliveryCompanies"
        :search="search"
        :loading="isLoading"
        :loading-text="$t('loading_data')"
        class="ordera-box-shadow striped-table"
        show-expand
      >
        <template v-slot:top>
          <v-divider></v-divider>
        </template>
        <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
          <template v-if="item.children && item.children.length">
            <v-btn
              color="primary"
              dark
              small
              rounded
              @click="expand(true)"
              v-if="!isExpanded && $store.state.restaurant != null"
            >
              <v-icon>mdi-arrow-down</v-icon>
              {{ $t("branches") }}
            </v-btn>
            <v-btn color="primary" dark small rounded @click="expand(false)" v-else>
              <v-icon>mdi-arrow-up</v-icon>
              {{ $t("hide") }}
            </v-btn>
          </template>
        </template>

        <template v-slot:expanded-item="{ item, isExpanded, expand }">
          <template v-if="item.children">
            <td :colspan="headers.length" class="pa-0">
              <v-data-table
                dense
                :headers="headers"
                class="ordera-box-shadow striped-table"
                :items="item.children || []"
                :items-per-page="item.children.length"
                hide-default-footer
                hide-default-header
              >
                <v-spacer></v-spacer>
                <template v-slot:item.city_id="{ item }">
                  {{ cityName(item.city_id) }}
                </template>
                <template v-slot:item.actions="{ item, index }">
                  <v-btn
                    v-if="canSeeFirmUsers(item)"
                    small
                    color="primary"
                    text
                    :to="{
                      name: 'firma-dostava-id-korisnici',
                      params: {
                        id: item.id,
                        name: item.name,
                        parent_id: item.parent_id,
                      },
                    }"
                  >
                    {{ $t("users") }} {{ item.active_users_count ?? item.users_count }}
                  </v-btn>

                  <template v-if="canManageCompanies">
                    <edit-button class="mr-2" @click="editCompany(item)"></edit-button>
                    <circle-button
                      @click="openCompanySettings(item)"
                      icon="mdi-cog-outline"
                      :tooltip="$t('join_restoran')"
                    />
                  </template>
                </template>
              </v-data-table>
            </td>
          </template>
        </template>
        <template v-slot:item.city_id="{ item }">
          {{ cityName(item.city_id) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters justify="end">
            <v-btn
              small
              color="primary"
              text
              class="mx-2"
              :to="{
                name: 'firma-dostava-id-korisnici',
                params: {
                  id: item.id,
                  name: item.name,
                  parent_id: item.parent_id,
                },
              }"
              v-if="canSeeFirmUsers(item) && item.restaurant_id"
            >
              {{ $t("users") }} {{ item.active_users_count ?? item.users_count }}
            </v-btn>
            <span v-if="canManageCompanies" style="display: flex; align-items: center">
              <edit-button
                v-if="item.restaurant_id"
                class="mr-2"
                @click="editCompany(item)"
              ></edit-button>
              <circle-button
                v-if="item.restaurant_id"
                @click="openCompanySettings(item)"
                icon="mdi-cog-outline"
                :tooltip="$t('join_restoran')"
              />
            </span>
            <span
              v-else-if="$store.state.user.user.type === 'dostava'"
              style="display: flex; justify-content: center"
            >
              <v-switch
                @click="changeUserDeliveryStatus(item.delivery_company_user[0])"
                v-model="item.delivery_company_user[0].active_company"
                inset
                :false-value="0"
                :true-value="1"
                :label="$t('status')"
              ></v-switch>
              <span
                :style="
                  item.delivery_company_user[0].active_company
                    ? 'background:rgb(90, 228, 90) !important'
                    : 'background:red !important'
                "
                style="
                  padding: 4px;
                  border-radius: 10px;
                  display: block;
                  height: 3px;
                  margin-top: 21px;
                  margin-left: 7px;
                "
              ></span>
            </span>
          </v-row>
        </template>
        <template
          v-if="$store.state.user.user.type == 'restaurant'"
          v-slot:item.status="{ item }"
        >
          <span style="display: flex; justify-content: center; margin-left: 10px">
            <v-switch
              style="padding-top: 15px"
              @click="changeCompanyDeliveryStatus(item.restaurant_delivery_company[0])"
              v-model="item.restaurant_delivery_company[0].active_company"
              inset
              title="Приврмено (де)активрај фирму за доставу. Деактивираним фирмама се не прослеђују наруџбе."
              :false-value="0"
              :true-value="1"
            ></v-switch>
            <span
              :style="
                item.restaurant_delivery_company[0].active_company
                  ? 'background:rgb(90, 228, 90) !important'
                  : 'background:red !important'
              "
              style="
                padding: 4px;
                border-radius: 10px;
                display: block;
                height: 3px;
                margin-top: 23px;
                margin-left: 0px;
              "
            ></span>
          </span>
        </template>
      </v-data-table>
    </div>

    <delivery-report-dialog
      v-model="isReportDialogOpen"
      :delivery-company="selectedDeliveryCompany"
      :delivery-company-users="selectedDeliveryCompanyUsers"
      @close="isReportDialogOpen = false"
      @save="onReportSave"
    />

    <restaurant-settings-dialog
      v-model="isSettingsDialogOpen"
      :firm="selectedCompany"
      :countries="countries"
      :cities="cities"
      :edited-item="editedCompany"
      @country-change="loadCitiesForCountry"
      @saved="
        isSettingsDialogOpen = false;
        loadDeliveryCompanies();
      "
      @close="isSettingsDialogOpen = false"
    />

    <restaurant-own-delivery-settings-dialog
      v-model="isOwnLinkDialogOpen"
      :firm="selectedCompany"
      @saved="
        isOwnLinkDialogOpen = false;
        loadDeliveryCompanies();
      "
      @close="isOwnLinkDialogOpen = false"
    />

    <delivery-company-dialog
      v-if="$store.state.user.user.type != 'dostava' && $store.state.restaurant != null"
      v-model="isCompanyDialogOpen"
      :edited-item="editedCompany"
      :companies="deliveryCompanies"
      :countries="countries"
      :cities="cities"
      @company-created="loadDeliveryCompanies"
      @company-updated="loadDeliveryCompanies"
      @country-change="loadCitiesForCountry"
      @close="closeCompanyDialog"
    />
  </div>
</template>

<script>
import DeliveryCompanyDialog from "@/components/companies/dialogs/DeliveryCompanyDialog.vue";
import DeliveryReportDialog from "@/components/companies/dialogs/DeliveryReportDialog.vue";
import RestaurantSettingsDialog from "@/components/companies/dialogs/RestaurantSettingsDialog.vue";
import RestaurantOwnDeliverySettingsDialog from "@/components/companies/dialogs/RestaurantOwnDeliverySettingsDialog.vue";
import hasSnackbar from "@/mixins/hasSnackbar";
import { deliveryCompany } from "@/models/company";
import restaurantService from "@/services/restaurant";
import companyService from "@/services/company";
import postService from "@/services/post";

/**
 * Stara stranica Firme za dostavu (?ui=stari). Nije mijenjana osim dugmeta "Novi izgled" u zaglavlju;
 * novi izgled je u components/delivery-firms-shell.
 */
export default {
  name: "DeliveryLegacy",
  mixins: [hasSnackbar],
  components: {
    DeliveryCompanyDialog,
    DeliveryReportDialog,
    RestaurantSettingsDialog,
    RestaurantOwnDeliverySettingsDialog,
  },
  data: () => ({
    isCompanyDialogOpen: false,
    selectedCompany: {
      settings: {
        confirm_delivery: false,
        order_from_one_shift_to_another: true,
        can_see_report: false,
      },
    },
    cities: [],
    allCities: [],
    search: "",
    isReportDialogOpen: false,
    isSettingsDialogOpen: false,
    isOwnLinkDialogOpen: false,
    deliveryCompanies: [],
    editedCompany: { ...deliveryCompany },
    countries: [],
    selectedDeliveryCompanyUsers: [],
    selectedDeliveryCompany: null,
    isLoading: false,
  }),

  computed: {
    // Creating / editing a delivery company (commission, cash limits, liability,
    // JIB/PIB, settings, credit) is an owner action. A dispatcher (admin_delivery)
    // or courier (dostava) must not see those affordances — they only manage the
    // firm's users.
    canManageCompanies() {
      return ["admin", "restaurant"].includes(this.$store.state.user.user.type);
    },
    headers() {
      return [
        {
          text: "ID",
          align: "end",
          value: "id",
        },
        {
          text: this.$t("title"),
          align: "start",
          value: "name",
        },
        {
          text: this.$t("city"),
          align: "start",
          value: "city_id",
          sortable: false,
        },
        {
          text: this.$t("email"),
          align: "start",
          value: "email",
          sortable: false,
        },
        {
          text: this.$t("phone_no"),
          align: "start",
          value: "phone",
          sortable: false,
        },
        {
          text: this.$t("actions"),
          align: "end",
          value: "actions",
          sortable: false,
        },
        {
          text: "",
          value: "data-table-expand",
        },
      ];
    },
  },

  watch: {
    isCompanyDialogOpen(val) {
      val || this.closeCompanyDialog();
    },
  },

  created() {
    this.loadDeliveryCompanies();
    this.loadCountries();
    this.loadAllCities();
    this.$root.$on("changeWebSite", () => {
      this.loadDeliveryCompanies();
    });
    if (this.$store.state.user.user.type == "restaurant") {
      this.headers.push({
        text: this.$t("status"),
        align: "center",
        value: "status",
        sortable: false,
      });
    }
  },
  methods: {
    // "Korisnici" button visibility. A restaurant user may manage users only for
    // its OWN delivery firm — the one linked to this restaurant with internal: 1
    // (backend gates /companies/:id/users-delivery the same way; external firms
    // return 403). admin sees all; dostava/admin_delivery are bounced to the
    // Kurir app so they never reach this screen.
    canSeeFirmUsers(item) {
      const type = this.$store.state.user.user.type;
      if (type === "restaurant") {
        const restaurantId =
          this.$store.state.restaurant && this.$store.state.restaurant.id;
        return (item.restaurant_delivery_company || []).some(
          (row) => row.restaurant_id === restaurantId && Number(row.internal) === 1
        );
      }
      return type !== "dostava";
    },
    async changeCompanyDeliveryStatus(item) {
      try {
        item.res_id = item.restaurant_id;
        await companyService.changeCompanyDeliveryStatus(item);
        this.showSuccessSnackbar(this.$t("company_delivery_status_updated"));
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_updating_company_delivery_status"));
      }
    },
    async changeUserDeliveryStatus(item) {
      try {
        await companyService.changeUserDeliveryStatus(item);
        this.showSuccessSnackbar(this.$t("user_delivery_status_updated"));
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_updating_user_delivery_status"));
      }
    },
    loadCitiesForCountry() {
      let cityes = [];
      this.countries.filter((item) => {
        item.city.filter((city) => {
          this.editedCompany.country.city.filter((c) => {
            if (city.id == c.id) {
              cityes.push(city);
            }
          });
        });
      });
      this.cities = cityes;
    },
    async loadAllCities() {
      try {
        const { data } = await postService.getAllCities();
        this.allCities = data;
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_cities"));
      }
    },
    cityName(cityId) {
      if (!cityId) return "";
      const city = this.allCities.find((c) => c.id == cityId);
      return city ? city.name : "";
    },
    async loadCountries() {
      try {
        const { data } = await restaurantService.getCountriesAll();
        this.countries = data;
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_countries"));
      }
    },
    openCompanySettings(company) {
      // A plain restaurant only ever manages its OWN cooperation with this
      // firm - give it the minimal, single-row dialog instead of the
      // admin-oriented "every restaurant on this firm" table.
      if (this.$store.state.user.user.type === "restaurant") {
        this.selectedCompany = company;
        this.isOwnLinkDialogOpen = true;
        return;
      }
      this.selectedCompany = company;
      this.editedCompany = JSON.parse(JSON.stringify(company));
      this.isSettingsDialogOpen = true;
    },
    async loadDeliveryCompanies() {
      this.isLoading = true;
      try {
        const res = await companyService.getDeliveryCompanies();
        let companies = res.data;
        if (this.$store.state.user.user.type == "dostava") {
          const restaurantId = this.$store.state.restaurant.id;
          companies = companies.filter((item) => {
            return (
              item.restaurant_delivery_company &&
              item.restaurant_delivery_company.some(
                (itemR) => itemR.restaurant_id == restaurantId
              )
            );
          });
        }
        this.deliveryCompanies = companies;
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_delivery_companies"));
      } finally {
        this.isLoading = false;
      }
    },
    editCompany(company) {
      // Create deep copy of the company
      this.editedCompany = JSON.parse(JSON.stringify(company));
      // The server only stores/returns city_id (country_id is not a real
      // column - confirmed 12.09.2026 backend answer, B2), so on edit the
      // country/city dropdowns have nothing to preselect from unless we
      // derive them ourselves: find which country's city list contains this
      // city_id, then populate both dropdowns from that.
      if (this.editedCompany.city_id) {
        const match = this.findCountryAndCityById(this.editedCompany.city_id);
        if (match) {
          this.editedCompany.country = match.country;
          this.editedCompany.city = match.city;
          this.loadCitiesForCountry();
        }
      }
      this.isCompanyDialogOpen = true;
    },
    findCountryAndCityById(cityId) {
      for (const country of this.countries) {
        const city = (country.city || []).find((c) => c.id == cityId);
        if (city) return { country, city };
      }
      return null;
    },
    closeCompanyDialog() {
      this.isCompanyDialogOpen = false;
      this.$nextTick(() => {
        this.editedCompany = { ...deliveryCompany };
      });
    },

    onReportSave() {
      this.isReportDialogOpen = false;
    },

    print() {
      window.print();
    },
  },
};
</script>
